import "./Consultancy.scss";
import WebLayout from "../../components/weblayout/WebLayout";
import ConsultancyLanding from "./consultancyLanding/ConsultancyLanding";
import { useNavigate } from "react-router-dom";
import ConsultKeyAreas from "./consultKeyAreas/ConsultKeyAreas";
import CTA from "../../components/cta/CTA";
import PageLoader from "../../lms/lmsComponents/pageLoader/PageLoader";
import { Fragment, useEffect, useState } from "react";
import { baseUrl, consultancyPagee } from "../../utils/apiData";
import axios from "axios";

const Consultancy = () => {
  const navigate = useNavigate();

  const[data, setdata] = useState({});
  const [loader, setLoader] = useState(false);

  const coachingPageApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${consultancyPagee}`);
      if (res?.data?.success) {
        setdata(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    coachingPageApi();
  }, []);

  return (
    <WebLayout>
      {loader ? (
        <PageLoader />
      ) : (
        <Fragment>
          <ConsultancyLanding data={data} />
          <ConsultKeyAreas data={data} />
          <CTA
            title="Ready for the Unprecedented?"
            btnText="Get in Touch"
            clickHandler={() => navigate(`/contact`)}
          />
        </Fragment>
      )}    
    </WebLayout>
  );
};
export default Consultancy;
